import { Box } from "@chakra-ui/layout"
import { AppEntityHydrated } from "@jackfruit/common"
import React from "react"
import FooterBlock from "../../../components/blocks/FooterBlock"

interface Props {
  config: AppEntityHydrated
}

const Footer: React.FC<Props> = ({ config }) => {
  const pageWithFooter = config.pages.find(page =>
    page.blocks.some(block => block.type === "footer")
  )

  const footerBlock = pageWithFooter?.blocks.find(
    block => block.type === "footer"
  )

  if (!footerBlock) {
    return null
  }

  const footerConfig = config.blockFooters.find(
    footer => Number(footer.id) === Number(footerBlock.footerId)
  )

  if (!footerConfig) {
    return null
  }

  return (
    <Box className="block-footer">
      <FooterBlock config={footerConfig} appConfig={config} />
    </Box>
  )
}

export default Footer
